"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.number.constructor");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _elementUi = require("element-ui");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SettingsComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(SettingsComponent, _Mixins);

  var _super = _createSuper(SettingsComponent);

  function SettingsComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, SettingsComponent);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.customerId = '';
    _this.code = '';
    _this.default19Visible = false;
    _this.default19Value = '';
    _this.formData = {
      lastmiledelivery: {
        // Overflow Order Check
        default1: false,
        // Time Window Check
        default2: false,
        // Default Time Window Buffer
        // default13: 0,
        // Is Vehicle Returning
        default3: false,
        // Max Distance
        default11: 24,
        // Additional Constraints
        default12: [],
        // Manual Assign Ignore Capacity
        default9: false,
        // Auto Assign Grouping
        default4: false,
        // Capacity3 (additional constraints) time buffer
        default15: 0,
        // truckCommodityType (additional constraints) mapping
        default16: [{
          truck: '',
          commodity: ''
        }],
        // auto assign truck minimum order percentage
        default17: 70,
        // Auto Assign Optimize Truck
        default20: false,
        // consider time window in grouping
        default24: false,
        // priority count auto assign
        default25: 1,
        // total running max km distance
        default26: 100,
        // if use the real / hardcoded 15mins processing time
        default27: false,
        // if will assign the invalid orders to all available vehicles
        default28: false,
        // travel time padding percentage
        default29: 0,
        // consider time window in grouping
        default32: false,
        // capacity padding percentage
        default33: 0
      },
      milkrun: {
        // Milkrun Time Interval
        default14: 30,
        // milkrun v2 push notification
        default21: false,
        // milkrun v2 yellow alert type time
        default22: 60,
        // milkrun v2 red alert type time
        default23: 1800
      },
      railway: {
        // Railway Time Interval
        default18: 30,
        // Railway Plan Code
        default19: []
      },

      /*'urls': {
      'hook1': '',
      'hook2': '',
      'hook3': '',
      'hook4': ''
      },*/
      global: {
        // Is china
        default10: false,
        // Is using Google API
        default5: false,
        // Default Start Time
        default6: '',
        // Default Waiting Time
        default7: 0,
        // Default Handling Time
        default8: 0
      }
    };
    _this.backupData = {
      lastmiledelivery: {},
      milkrun: {},
      railway: {}
    }; // private settingsFormRules: object = {};

    _this.activeName = 'global';
    return _this;
  }

  (0, _createClass2.default)(SettingsComponent, [{
    key: "onChangeTimeWindow",
    value: function onChangeTimeWindow(newVal) {
      if (this.formData && this.formData['lastmiledelivery'] && newVal === false) {
        this.formData['lastmiledelivery']['default24'] = false;
      }
    }
  }, {
    key: "onChangeGroup",
    value: function onChangeGroup(newVal) {
      if (this.formData && this.formData['lastmiledelivery']) {
        this.formData['lastmiledelivery']['default32'] = newVal;
      }
    }
  }, {
    key: "form",
    get: function get() {
      return this.$refs['settingsForm'];
    }
  }, {
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      }
    }
  }, {
    key: "created",
    value: function created() {
      var _this2 = this;

      this.loading = true;
      var today = new Date();
      this.code = today.getFullYear() + '-' + this.helper.pad(today.getMonth() + 1) + '-' + this.helper.pad(today.getDate()); // this.settingsFormRules = {
      //   hook1: [{ validator: this.validUrl, trigger: 'change' }],
      //   hook2: [{ validator: this.validUrl, trigger: 'change' }],
      //   hook3: [{ validator: this.validUrl, trigger: 'change' }],
      //   hook4: [{ validator: this.validUrl, trigger: 'change' }]
      // };

      this.requestParameters[process.env.VUE_APP_CUSTOMER_KEY] = process.env.VUE_APP_CUSTOMER_KEY_HASH;
      this.request.get('AI_CUSTOMER', this.$userInformation.customerKey, _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        key: 'key'
      })).then(function (data) {
        if (!data['data']) {
          return Promise.reject('');
        }

        _this2.customerId = data['data']['_id'] || '';
        _this2.formData = {
          lastmiledelivery: {
            default1: _this2.checkTrue(data['data']['default1'] || ''),
            default2: _this2.checkTrue(data['data']['default2'] || ''),
            // default13: data['data']['default13'] ? Number(data['data']['default13']) / 60 : 0,
            default3: _this2.checkTrue(data['data']['default3'] || ''),
            default4: _this2.checkTrue(data['data']['default4'] || ''),
            default9: _this2.checkTrue(data['data']['default9'] || ''),
            default11: data['data']['default11'] ? Number(data['data']['default11']) : 24,
            default12: data['data']['default12'] ? data['data']['default12'].split('|') : [],
            default15: data['data']['default15'] ? Number(data['data']['default15']) / 60 : 0,
            default16: data['data']['default16'] ? data['data']['default16'] : [{
              truck: '',
              commodity: ''
            }],
            default17: data['data']['default17'] ? Number(data['data']['default17']) : 70,
            default20: _this2.checkTrue(data['data']['default20'] || ''),
            default24: _this2.checkTrue(data['data']['default24'] || ''),
            default25: data['data']['default25'] ? Number(data['data']['default25']) : 1,
            default26: data['data']['default26'] ? Number(data['data']['default26']) : 100,
            default27: _this2.checkTrue(data['data']['default27'] || ''),
            default28: _this2.checkTrue(data['data']['default28'] || ''),
            default29: data['data']['default29'] ? Number(data['data']['default29']) : 0,
            default31: _this2.checkTrue(data['data']['default31'] || ''),
            default32: _this2.checkTrue(data['data']['default32'] || ''),
            default33: data['data']['default33'] ? Number(data['data']['default33']) : 0
          },
          milkrun: {
            default14: data['data']['default14'] ? Number(data['data']['default14']) : 30,
            default21: _this2.checkTrue(data['data']['default21'] || ''),
            default22: data['data']['default22'] ? Number(data['data']['default22']) : 60,
            default23: data['data']['default23'] ? Number(data['data']['default23']) : 1800
          },
          railway: {
            default18: data['data']['default18'] ? Number(data['data']['default18']) : 30,
            default19: data['data']['default19'] ? data['data']['default19'] : []
          },

          /*'urls': {
          'hook1': (data['data']['hook1']) ? data['data']['hook1'] : '',
          'hook2': (data['data']['hook2']) ? data['data']['hook2'] : '',
          'hook3': (data['data']['hook3']) ? data['data']['hook3'] : '',
          'hook4': (data['data']['hook4']) ? data['data']['hook4'] : ''
          },*/
          global: {
            default10: _this2.checkTrue(data['data']['default10'] || ''),
            default5: _this2.checkTrue(data['data']['default5'] || ''),
            default6: data['data']['default6'] ? data['data']['default6'] : '',
            default7: data['data']['default7'] ? Number(data['data']['default7']) / 60 : 0,
            default8: data['data']['default8'] ? Number(data['data']['default8']) / 60 : 0
          }
        };

        if (_this2.hasPermission('lastMileDelivery')) {
          _this2.request.get('AI_BACKUP', 'routing', _objectSpread(_objectSpread({}, _this2.requestParameters), {}, {
            code: _this2.code,
            customerId: _this2.customerId
          })).then(function (backData) {
            if (!backData['data']) {
              return Promise.reject('');
            }

            _this2.backupData['lastmiledelivery'] = backData['data'];
          }).catch(function () {
            _this2.logger.error('invalid lastmile backup');
          });
        }

        if (_this2.hasPermission('milkRun')) {
          _this2.request.get('AI_BACKUP', 'schedule', _objectSpread(_objectSpread({}, _this2.requestParameters), {}, {
            startDate: _this2.code,
            endDate: _this2.code,
            customerId: _this2.customerId
          })).then(function (backData) {
            if (!backData['data']) {
              return Promise.reject('');
            }

            _this2.backupData['milkrun'] = backData['data'];
          }).catch(function () {
            _this2.logger.error('invalid milkrun backup');
          });
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.logger.error('invalid customer');

        _this2.loading = false;
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.loading = false;
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this3 = this;

      if (this.helper.isEmpty(this.customerId)) {
        var message = {
          title: this.$i18n.t('notification.settings.updateFailed'),
          duration: 5000
        };

        _elementUi.Notification.error(message);

        return;
      }

      this.form.validate(function (valid) {
        if (valid) {
          var cleanData = _this3.cleanFormData(_this3.formData[_this3.activeName]); // const cleanData: object = this.cleanFormData({
          //   ...this.formData['lastmiledelivery'],
          //   ...this.formData['milkrun'],
          //   ...this.formData['global'],
          // });


          _this3.logger.info("form submitted: ".concat(JSON.stringify(cleanData)));

          _this3.request.put('AI_CUSTOMER', _this3.customerId, _this3.requestParameters, cleanData).then(function (data) {
            if (data.failed) {
              return Promise.reject(data.message || '');
            }

            _this3.$updateUserSetting(cleanData);

            var message = {
              title: _this3.$i18n.t('notification.settings.updateTabSuccess'),
              duration: 5000
            };

            _elementUi.Notification.success(message);
          }).catch(function (error) {
            var message = {
              title: _this3.helper.toString(error),
              duration: 5000
            };

            _elementUi.Notification.error(message);
          });
        }
      });
    }
  }, {
    key: "cleanFormData",
    value: function cleanFormData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var newData = _objectSpread({}, data);

      if (this.activeName === 'global') {
        var startTime = newData['default6'];
        newData['default6'] = startTime ? startTime.length === 8 ? startTime : "".concat(startTime.substring(0, 5), ":00") : '';
        newData['default7'] = newData['default7'] ? Number(newData['default7']) * 60 : 0;
        newData['default8'] = newData['default8'] ? Number(newData['default8']) * 60 : 0; // newData['default30'] = newData['default30'] ? newData['default30'] : 'default';
      }

      if (this.activeName === 'lastmiledelivery') {
        // newData['default13'] = newData['default13'] ? Number(newData['default13']) * 60 : 0;
        newData['default12'] = newData['default12'] ? newData['default12'].join('|') : '';
        newData['default15'] = newData['default15'] ? Number(newData['default15']) * 60 : 0;
        newData['default16'] = newData['default16'] ? this.helper.removeDuplicateArrayObject(newData['default16'], 'truck') : [{
          truck: '',
          commodity: ''
        }];
      }

      return this.helper.cleanDataRemoveNull(newData);
    } // validUrl(rule, value, callback) {
    //   const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    //     '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    //     '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    //     '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    //   if (!pattern.test(value) && !this.helper.isUndefined(value)) {
    //     return callback(new Error ('Not a valid website address.'));
    //   } else {
    //     callback();
    //   }
    // }

  }, {
    key: "checkTrue",
    value: function checkTrue(data) {
      return data && data !== '' && (data === 'True' || data === 'true') ? true : false;
    }
  }, {
    key: "hasPermission",
    value: function hasPermission() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (name) {
        if (name === 'global') {
          return true;
        }

        if (this.helper.isInArray(name, this.$userData.permission)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "addTruckCommodityType",
    value: function addTruckCommodityType() {
      this.formData['lastmiledelivery']['default16'].push({
        truck: '',
        commodity: ''
      });
    }
  }, {
    key: "removeTruckCommodityType",
    value: function removeTruckCommodityType(idx) {
      this.formData['lastmiledelivery']['default16'].splice(idx, 1);
    }
  }, {
    key: "hasBackup",
    value: function hasBackup() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var hasback = false;

      switch (param) {
        case 'lastmiledelivery':
          hasback = this.helper.isEmptyObject(this.backupData[param]);
          break;

        case 'milkrun':
          hasback = this.backupData[param].length === 0;
          break;
      }

      return hasback;
    }
  }, {
    key: "routingInformation",
    value: function routingInformation() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var infoString = '';

      if (!this.backupData[param]) {
        infoString = this.$i18n.t('general.nobackupdata');
      }

      switch (param) {
        case 'lastmiledelivery':
          if (this.helper.isEmptyObject(this.backupData[param])) {
            infoString = this.$i18n.t('general.nobackupdata');
          } else {
            infoString = "(".concat(this.backupData[param]['backupNumber'], ") - ").concat(this.backupData[param]['backupDate']);
          }

          break;

        case 'milkrun':
          if (this.backupData[param].length === 0 || !this.backupData[param][0]) {
            infoString = this.$i18n.t('general.nobackupdata');
          } else {
            infoString = "(".concat(this.backupData[param][0]['backupNumber'], ") - ").concat(this.backupData[param][0]['backupDate']);
          }

          break;
      }

      return infoString;
    } // confirmRestore(param: string = '') {
    // 	if (this.hasBackup(param)) {
    // 		return false;
    // 	}
    // 	const message: string = this.$i18n.t('settings.confirmRestoreBackup') as string;
    // 	MessageBox.confirm(`${message} ${this.code}?`, 'Warning', {
    // 		confirmButtonText: this.$i18n.t('pickColumns.confirm') as string,
    // 		cancelButtonText: this.$i18n.t('pickColumns.cancel') as string,
    // 		type: 'warning',
    // 		center: true,
    // 	})
    // 		.then(() => {
    // 			this.restoreBackup(param);
    // 		})
    // 		.catch(() => {});
    // }
    // restoreBackup(param: string = '') {
    // 	switch (param) {
    // 		case 'lastmiledelivery':
    // 			this.request
    // 				.put('AI_BACKUP', 'routing', this.requestParameters, {
    // 					code: this.code,
    // 					customerId: this.customerId,
    // 				})
    // 				.then((backData) => {
    // 					const message: ElNotificationOptions = {
    // 						title: this.$i18n.t('notification.settings.backupRestoreSuccess'),
    // 						duration: 5000,
    // 					} as ElNotificationOptions;
    // 					Notification.success(message);
    // 				})
    // 				.catch((error) => {
    // 					const message: ElNotificationOptions = {
    // 						title: this.$i18n.t('notification.settings.backupRestoreFailed'),
    // 						duration: 5000,
    // 					} as ElNotificationOptions;
    // 					Notification.error(message);
    // 				});
    // 			break;
    // 		case 'milkrun':
    // 			this.request
    // 				.put('AI_BACKUP', 'schedule', this.requestParameters, {
    // 					startDate: this.code,
    // 					endDate: this.code,
    // 					customerId: this.customerId,
    // 				})
    // 				.then((backData) => {
    // 					const message: ElNotificationOptions = {
    // 						title: this.$i18n.t('notification.settings.backupRestoreSuccess'),
    // 						duration: 5000,
    // 					} as ElNotificationOptions;
    // 					Notification.success(message);
    // 				})
    // 				.catch((error) => {
    // 					const message: ElNotificationOptions = {
    // 						title: this.$i18n.t('notification.settings.backupRestoreFailed'),
    // 						duration: 5000,
    // 					} as ElNotificationOptions;
    // 					Notification.error(message);
    // 				});
    // 			break;
    // 	}
    // }
    // custom function for default19

  }, {
    key: "default19Close",
    value: function default19Close(tag) {
      this.formData['railway']['default19'].splice(this.formData['railway']['default19'].indexOf(tag), 1);
    }
  }, {
    key: "default19ShowInput",
    value: function default19ShowInput() {
      var _this4 = this;

      this.default19Visible = true;
      this.$nextTick(function () {
        var inputRef = _this4.$refs.saveDefault19Input;
        inputRef.$refs.input.focus();
      });
    }
  }, {
    key: "default19InputConfirm",
    value: function default19InputConfirm() {
      var inputValue = this.default19Value;

      if (inputValue) {
        this.formData['railway']['default19'].push(inputValue);
      }

      this.default19Visible = false;
      this.default19Value = '';
    } // custom function for default19

  }, {
    key: "clearRoutingCache",
    value: function clearRoutingCache() {
      var _this5 = this;

      this.request.post('ROUTING', 'v1/noauth/clearcache', this.requestParameters).then(function (cacheData) {
        if (cacheData.failed) {
          return Promise.reject(cacheData.message || '');
        }

        var message = {
          title: _this5.$i18n.t('notification.settings.clearCacheSuccess'),
          duration: 5000
        };

        _elementUi.Notification.success(message);
      }).catch(function (error) {
        var message = {
          title: _this5.$i18n.t('notification.settings.clearCacheFailed'),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      });
    }
  }, {
    key: "clearDataCache",
    value: function clearDataCache() {
      var _this6 = this;

      this.request.post('LEGACY_TOOL', 'clear-cache', this.requestParameters).then(function (cacheData) {
        if (cacheData.failed) {
          return Promise.reject(cacheData.message || '');
        }

        var message = {
          title: _this6.$i18n.t('notification.settings.clearCacheSuccess'),
          duration: 5000
        };

        _elementUi.Notification.success(message);
      }).catch(function (error) {
        var message = {
          title: _this6.$i18n.t('notification.settings.clearCacheFailed'),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      });
    }
  }, {
    key: "kickLastmileUser",
    value: function kickLastmileUser() {
      var _this7 = this;

      return this.request.post('ROUTING_SOCKET', 'v1/core/lastmile/socketdisconnect', _objectSpread(_objectSpread({}, this.requestParameters), {}, (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation.customerKey)), {
        userEmail: this.$userInformation.user.name
      }).then(function (requestData) {
        if (requestData.failed) {
          return Promise.reject(requestData.message || '');
        }

        var message = {
          title: _this7.$i18n.t('notification.settings.socketDisconnectSuccess'),
          duration: 5000
        };

        _elementUi.Notification.success(message);
      }).catch(function (error) {
        var message = {
          title: _this7.$i18n.t('notification.settings.socketDisconnectFailed'),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      });
    }
  }]);
  return SettingsComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], SettingsComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], SettingsComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('updateUserSetting', {
  namespace: 'authentication'
})], SettingsComponent.prototype, "$updateUserSetting", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('formData.lastmiledelivery.default2')], SettingsComponent.prototype, "onChangeTimeWindow", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('formData.lastmiledelivery.default4')], SettingsComponent.prototype, "onChangeGroup", null);
SettingsComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'SettingsComponent',
  components: {
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-switch': _elementUi.Switch,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-button': _elementUi.Button,
    'el-input': _elementUi.Input,
    'el-col': _elementUi.Col,
    'el-time-picker': _elementUi.TimePicker,
    'el-input-number': _elementUi.InputNumber,
    'el-tabs': _elementUi.Tabs,
    'el-tag': _elementUi.Tag,
    'el-tab-pane': _elementUi.TabPane
  }
})], SettingsComponent);
var _default = SettingsComponent;
exports.default = _default;